import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { array, func, object, string } from "prop-types";

import StaticHeader from "./StaticHeader";
import VerticalMenubar from "../VerticalMenubar";

import { setMobileFilter, setDateParams } from "../../../helper/actions";
import { useDeviceWidth } from "../../../utils/react-utils";
import { getCurrentSite } from "../../../utils/utils";

import "./uniformHeader.m.css";

const UniformHeader = ({ domainMenuItemsObj, setMobileFilter, setDateParams }) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [hamburgerMenu, setHamburgerMenu] = useState({});
  const [location, setLocation] = useState(null);
  const [originalLocation, setoriginalLocation] = useState(null);
  const [isVerticalMenubar, setVerticalMenuBar] = useState(false);

  useEffect(() => {
    isVerticalMenubar
      ? (global.document.body.style.overflow = "hidden")
      : (global.document.body.style.cssText = "overflow-x: hidden, overflow-y: auto");
  }, [isVerticalMenubar]);

  useEffect(() => {
    if (domainMenuItemsObj.length > 0) {
      const hamItems = domainMenuItemsObj.find((item) => item.title === "hamburger");
      setHamburgerMenu(get(hamItems, ["children"], []));
    }
  }, [domainMenuItemsObj]);

  useDeviceWidth(setIsDesktop);

  useEffect(() => {
    setVerticalMenuBar(false);
    setLocation(getCurrentSite(global.location.host));
    setoriginalLocation(global.location.host);
    isVerticalMenubar && setVerticalMenuBar(false);
  }, []);

  const toggleVerticalMenubar = () => {
    setVerticalMenuBar(!isVerticalMenubar);
    setMobileFilter(false);
    setDateParams("");
  };

  const styleName = location ? location + "-wrapper" : "";

  return (
    <div styleName={`base`} className={styleName}>
      <StaticHeader
        toggleVerticalMenubar={toggleVerticalMenubar}
        isVerticalMenubar={isVerticalMenubar}
        location={location}
        originalLocation={originalLocation}
        isDesktop={isDesktop}
      />
      {isVerticalMenubar && (
        <VerticalMenubar
          isDesktop={isDesktop}
          toggleVerticalMenubar={toggleVerticalMenubar}
          hamburgerMenu={hamburgerMenu}
          domainSlug={location}
        />
      )}
    </div>
  );
};

UniformHeader.propTypes = {
  currentPath: string,
  publisherAttributes: object,
  sections: array,
  domainMenuItemsObj: array,
  navigateToPage: func,
  setMobileFilter: func,
  setDateParams: func,
};

const mapStateToProps = (state) => ({
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
  setDateParams: (date) => dispatch(setDateParams(date)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UniformHeader);
